function setupMobileMenu() {
  const headers = document.querySelectorAll(".site-header");

  const closeHeaderMenu = (header) => {
    const button = header.querySelector(".menu-toggle");
    header.classList.remove("nav-open");
    button?.setAttribute("aria-expanded", "false");
    button?.setAttribute("aria-label", "Open menu");
  };

  headers.forEach((header, index) => {
    const nav = header.querySelector(".nav-links");
    const brand = header.querySelector(".brand");

    if (!nav || !brand || header.querySelector(".menu-toggle")) {
      return;
    }

    const menuId = nav.id || `site-menu-${index + 1}`;
    nav.id = menuId;

    const button = document.createElement("button");
    button.className = "menu-toggle";
    button.type = "button";
    button.setAttribute("aria-label", "Open menu");
    button.setAttribute("aria-controls", menuId);
    button.setAttribute("aria-expanded", "false");
    button.innerHTML = "<span></span><span></span>";

    header.insertBefore(button, brand);

    button.addEventListener("click", () => {
      const isOpen = header.classList.toggle("nav-open");
      button.setAttribute("aria-expanded", String(isOpen));
      button.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
    });

    nav.addEventListener("click", (event) => {
      if (!event.target.closest("a")) {
        return;
      }

      closeHeaderMenu(header);
    });
  });

  document.addEventListener("click", (event) => {
    document.querySelectorAll(".site-header.nav-open").forEach((header) => {
      if (header.contains(event.target)) {
        return;
      }

      closeHeaderMenu(header);
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") {
      return;
    }

    document.querySelectorAll(".site-header.nav-open").forEach((header) => {
      closeHeaderMenu(header);
    });
  });
}

function setupHeaderMist() {
  const headers = document.querySelectorAll("body:not(.management-body) > .site-header");
  if (!headers.length) {
    return;
  }

  let ticking = false;

  const updateMist = () => {
    const shouldShowMist = window.scrollY > 18;
    headers.forEach((header) => {
      header.classList.toggle("mist-visible", shouldShowMist);
    });
    ticking = false;
  };

  updateMist();

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(updateMist);
    },
    { passive: true },
  );
}

setupMobileMenu();
setupHeaderMist();
